import { defineComponent as _defineComponent } from 'vue'
import { __ } from '@@/bits/intl'
import OzBox, { OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import OzDivider, { OzDividerColorScheme } from '@@/library/v4/components/OzDivider.vue'
import OzIconButton, {
  OzIconButtonColorScheme,
  OzIconButtonSizePreset,
} from '@@/library/v4/components/OzIconButton.vue'
import OzPlainButton, { OzPlainButtonSizePreset } from '@@/library/v4/components/OzPlainButton.vue'
import OzScreenSizeAwareSideModal from '@@/library/v4/components/OzScreenSizeAwareSideModal.vue'
import { useDarkModeStore } from '@@/pinia/dark_mode'
import { useSurfaceContainerSizeStore } from '@@/pinia/surface_container_size'
import { useWhiteboardStore } from '@@/pinia/whiteboard'
import SurfacePanelHeader from '@@/vuecomponents/SurfacePanelHeader.vue'
import SurfaceSharePanelCopyItemRow from '@@/vuecomponents/SurfaceSharePanelCopyItemRow.vue'
import { storeToRefs } from 'pinia'
import type { TLPageId } from 'tldraw'


export default /*#__PURE__*/_defineComponent({
  __name: 'WhiteboardFrameBreakoutLinksPanel',
  setup(__props) {

const { isContainerSmallerThanTabletPortrait, isContainerSmallerThanDesktop } = storeToRefs(
  useSurfaceContainerSizeStore(),
)
const { isDarkMode } = storeToRefs(useDarkModeStore())
const whiteboardStore = useWhiteboardStore()

const closePanel = () => {
  whiteboardStore.xFrameBreakoutLinksPanel = false
}

const copyFrameBreakoutLink = (frameId: string) => {
  whiteboardStore.copyFrameBreakoutLink(frameId as TLPageId)
}

return { __sfc: true,isContainerSmallerThanTabletPortrait, isContainerSmallerThanDesktop, isDarkMode, whiteboardStore, closePanel, copyFrameBreakoutLink, __, OzBox, OzBoxColors, OzDivider, OzDividerColorScheme, OzIconButton, OzIconButtonColorScheme, OzIconButtonSizePreset, OzPlainButton, OzPlainButtonSizePreset, OzScreenSizeAwareSideModal, SurfacePanelHeader, SurfaceSharePanelCopyItemRow }
}

})